import { datadogRum } from '@datadog/browser-rum';

export { DatadogSetup } from './DatadogSetup';

// eslint-disable-next-line @typescript-eslint/ban-types
export const logDataDogException = (...args: [unknown, object?]) => {
  datadogRum.addError(...args);
};
